import { Loader2Icon } from "lucide-react";
import { cn } from "@gerama/utils";

/** Inline mutation-pending spinner only — never used for a content area (skill 9.1 rule 1). */
export function Spinner({ className }: { className?: string }) {
  return <Loader2Icon className={cn("size-4 animate-spin", className)} />;
}
